import { api } from "./api";

export const studentRegistrationNo = async (addUrl = ``) => {
  return await api.get(`/student/registration_no?${addUrl}`);
};

export const hostelStudentList = async (addUrl = ``) => {
  return await api.get(`/hostels/students/list?${addUrl}`);
};

export const studentDelete = async (id) => {
  return await api.post(`/student/delete`, { id });
};

export const studentDetails = async (addUrl = "") => {
  return await api.get(`/student/details?${addUrl}`);
};

export const studentDetailsV2 = async (addUrl = "") => {
  return await api.get(`/student/details/v2?${addUrl}`);
};

export const studentDetailsV4 = async (addUrl = "") => {
  return await api.get(`/student/details/v4?${addUrl}`);
};

export const studentDueFeeDetails = async (addUrl = ``) => {
  return await api.get(`/student/due/fee/details?${addUrl}`);
};
export const studentDueFeeDetailsV4 = async (addUrl = ``) => {
  return await api.get(`/student/due/fee/details/v4?${addUrl}`);
};

export const studentFeeDeposit = async (data) => {
  return await api.post(`/student/fee/deposit`, data);
};
export const studentFeeDepositV4 = async (data) => {
  return await api.post(`/student/fee/deposit/v4`, data);
};

export const studentManualFeeDeposit = async (data) => {
  return await api.post(`/student/manual/fee/deposit`, data);
};

export const studentFeeReceiptNo = async (addUrl = ``) => {
  return await api.get(`/student/fee/receipt_no?${addUrl}`);
};

export const studentFeeReceipt = async (id) => {
  return await api.get(`/student/fee/receipt?id=${id}`);
};

export const studentFeeTransactionList = async (addUrl = ``) => {
  return await api.get(`/student/fee/deposit/list?${addUrl}`);
};

export const studentFeeTransactionDelete = async (id) => {
  return await api.post(`/student/fee/transaction/delete?id=${id}`);
};

export const studentFeeTransactionDeleteV4 = async (id) => {
  return await api.post(`/student/fee/transaction/delete/v4?id=${id}`);
};

export const studentBatchTransfer = async (data) => {
  return await api.post(`/student/batch/transfer`, data);
};

export const studentTuitionFeeChange = async (data) => {
  return await api.post(`/student/tuition/fee/change`, data);
};

export const studentTuitionFeeChangeV4 = async (data) => {
  return await api.post(`/student/tuition/fee/change/v4`, data);
};

export const StudentSearch = async (addUrl = ``) => {
  return await api.get(`/student/search?${addUrl}`);
};

export const studentAdd = async (data) => {
  return await api.post(`/student/add`, data);
};

export const studentBatchEnroll = async (data) => {
  return await api.post(`/student/batch/enroll`, data);
};

export const studentBatchEnrollV4 = async (data) => {
  return await api.post(`/student/batch/enroll/v4`, data);
};

export const studentsListOnly = async (addUrl = ``) => {
  return await api.get(`/students/list/only?${addUrl}`);
};

export const studentsList = async (addUrl = ``) => {
  return await api.get(`/students/list?${addUrl}`);
};

export const studentBusEnroll = async (data) => {
  return await api.post(`/student/bus/enroll`, data);
};

export const studentOldPaidFees = async (data) => {
  return await api.post(`/old/paid/fees`, data);
};

export const studentLoginStatusList = async (addUrl = ``) => {
  return await api.get(`/student/app/login/status?${addUrl}`);
};

export const studentImportWithEnroll = async (data) => {
  return await api.post("/student/import/enroll", data);
};
export const studentFeeOnlyImport = async (data) => {
  return await api.post("/student/import/fee-only", data);
};

export const studentFeeReport = async (addUrl = ``) => {
  return await api.get(`/student/fee/report?${addUrl}`);
};

export const studentFeeReportMonthWise = async (addUrl = ``) => {
  return await api.get(`/student/fee/report/month-wise?${addUrl}`);
};

export const studentFeeReportBatchWise = async (addUrl = ``) => {
  return await api.get(`/student/fee/report/batch-wise?${addUrl}`);
};

export const studentFeeTransactions = async (addUrl = ``) => {
  return await api.get(`/student/fee/transactions?${addUrl}`);
};

export const studentFeeTransactionsSummaryV2 = async (addUrl = ``) => {
  return await api.get(`/student/fee/transactions/summary/v2?${addUrl}`);
};

export const studentAllFeeTransactions = async (addUrl = ``) => {
  return await api.get(`/student/all/fee/transactions?${addUrl}`);
};

export const studentFeeTransactionAccept = async (data) => {
  return await api.post(`/student/fee/transaction/accept?`, data);
};

export const studentFeeMismatchReport = async (addUrl = ``) => {
  return await api.get(`/student/fee/mismatch/report?${addUrl}`);
};

export const studentDueFeeReport = async (addUrl = ``) => {
  return await api.get(`/student/due/fee/report?${addUrl}`);
};

export const studentDueFeeTypeWise = async (addUrl = ``) => {
  return await api.get(`/student/due/fee/type-wise?${addUrl}`);
};

export const allStudentFeeReport = async (addUrl = ``) => {
  return await api.get(`/all/student/fee/report?${addUrl}`);
};

export const studentFeeDiscountReport = async (addUrl = ``) => {
  return await api.get(`/student/fee/discount/report?${addUrl}`);
};

export const studentFeeTransactionsStatus4 = async (addUrl = ``) => {
  return await api.get(`/student/fee/transaction/status4?${addUrl}`);
};
export const studentFeeTransactionsDeleteStatus4 = async (data) => {
  return await api.post(`/student/fee/transaction/delete/status4`, data);
};

export const duplicateStudentsList = async (addUrl = ``) => {
  return await api.get(`/students/duplicate/list?${addUrl}`);
};

export const studentFeeTransactionReceiptNoUpdate = async (data) => {
  return await api.post(`/student/fee/transaction/receipt-no/update`, data);
};

export const studentManualFeeTransactions = async (data = {}) => {
  return await api.post(`/student/manual/fee/transactions`, data);
};

export const studentFeeTransactionHistory = async (addUrl = ``) => {
  return await api.get(`/student/fee/transaction/history?${addUrl}`);
};

export const familyStudentList = async (addUrl = ``) => {
  return await api.get(`/family/students/list?${addUrl}`);
};

export const familyFeeDetails = async (addUrl = ``) => {
  return await api.get(`/family/fee/details?${addUrl}`);
};

export const familyFeeDeposit = async (data) => {
  return await api.post(`/family/fee/deposit`, data);
};
